import {Action} from '@ngrx/store';
import {Update} from '@ngrx/entity';
import {UserModel} from '../models/user.model';
import {QueryParamsModel} from '../_base/crud';
import {NgxFileDropEntry} from 'ngx-file-drop';

export enum UserActionTypes {
    CREATE_USER = '[User Feature] Emit to create new user',
    USER_CREATED = '[User Feature] Emitted after the user has been created',
    UPDATE_USER = '[User Feature] Emit to update a user',
    USER_UPDATED = '[User Feature] Emitted after the user has been updated',
    DELETE_USER = '[User Feature] Emit to delete a user',
    MANY_USERS_DELETED = '[User Feature] Emit to delete many users',
    LOAD_USERS = '[User Feature] Emit to load a list of users',
    USERS_LOADING = '[User Feature] True while the users are being loaded',
    USERS_LOADED = '[User Feature] Emitted after a list of users has been loaded',
    USERS_BUSY = '[User Feature] True while an action on the users list is running',
    USERS_ERROR = '[User Feature] Emit when a user action results in an error'
}

export class CreateUserAction implements Action {
    readonly type = UserActionTypes.CREATE_USER;

    constructor(public payload: { user: UserModel, files: NgxFileDropEntry[], addWatcherIds?: number[], addUserGroupIds?: number[] }) {
    }
}

export class UserCreatedAction implements Action {
    readonly type = UserActionTypes.USER_CREATED;

    constructor(public payload: { user: UserModel }) {
    }
}

export class UpdateUserAction implements Action {
    readonly type = UserActionTypes.UPDATE_USER;

    constructor(
        public payload: {
            partialUser: Update<UserModel>,
            user: UserModel,
            files: NgxFileDropEntry[],
            addWatcherIds?: number[],
            removeWatcherIds?: number[] ,
            addUserGroupIds?: number[],
            removeUserGroupIds?: number[],
            current?: boolean,
        }) {
    }
}

export class UserUpdatedAction implements Action {
    readonly type = UserActionTypes.USER_UPDATED;

    constructor(public payload: { user: UserModel }) {
    }
}

export class DeleteUserAction implements Action {
    readonly type = UserActionTypes.DELETE_USER;

    constructor(public payload: { id: number }) {
    }
}

export class DeleteManyUsersAction implements Action {
    readonly type = UserActionTypes.MANY_USERS_DELETED;

    constructor(public payload: { ids: number[] }) {
    }
}

export class LoadUsersAction implements Action {
    readonly type = UserActionTypes.LOAD_USERS;

    constructor(public payload: { page: QueryParamsModel<UserModel> }, public reset: boolean = false) {
    }
}

export class UsersLoadedAction implements Action {
    readonly type = UserActionTypes.USERS_LOADED;

    constructor(public payload: { users: UserModel[], totalCount: number }) {
    }
}

export class UsersLoadingAction implements Action {
    readonly type = UserActionTypes.USERS_LOADING;

    constructor(public payload: { isLoading: boolean }) {
    }
}

export class UsersBusyAction implements Action {
    readonly type = UserActionTypes.USERS_BUSY;

    constructor(public payload: { isLoading: boolean }) {
    }
}

export class UsersError implements Action {
    readonly type = UserActionTypes.USERS_ERROR;

    constructor(public payload: { error_code: number, message: string }) {
    }
}

export type UserActions = UserCreatedAction
    | UpdateUserAction
    | UserUpdatedAction
    | DeleteUserAction
    | DeleteManyUsersAction
    | CreateUserAction
    | UsersLoadedAction
    | UsersLoadingAction
    | LoadUsersAction
    | UsersBusyAction
    | UsersError;
